// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const RoleNoneIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor" fillRule="evenodd">
      <path d="M21.06 20.13h-5.83c-.65 0-1.17-.52-1.17-1.17s.52-1.16 1.17-1.16h5.83c.65 0 1.17.52 1.17 1.16 0 .65-.52 1.17-1.17 1.17M10.27 1.5c-3.04 0-5.5 2.5-5.5 5.58s2.46 5.59 5.5 5.59 5.5-2.5 5.5-5.59-2.46-5.58-5.5-5.58" />
      <path
        d="M11.74 14.25H7.51c-3.1 0-5.74 2.67-5.74 5.82 0 .59 0 1.3.1 1.88l.02.12c.04.23.27.43.6.43h6.67c.38 0 .7-.23.85-.57l2.58-6.43c.24-.6-.2-1.25-.85-1.25"
        opacity=".5"
      />
    </g>
  </SvgIcon>
);

export default RoleNoneIcon;
